var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDistribution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3426 4.1029L10.914 7.82378L2.3426 6.66823V4.1029ZM10.914 14.1793L2.3426 17.9002V15.3349L10.914 14.1793ZM0.0568848 0.601562V8.69045L17.1997 11.0016L0.0568848 13.3127V21.4016L24.0569 11.0016L0.0568848 0.601562Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/distribution.dc6e8f2feace35a117b8a8cb21d2eb38.svg";
export { ForwardRef as ReactComponent };